import { Grid } from '@material-ui/core';
import { Conditional } from '../../../Checkout/program/step/lib/application.util';
import { FC, useState } from 'react';
import ForgotPasswordDialog from './ForgotPasswordDialog';
import SuccessDialog from './SuccessDialog';

/**
 * Bond Sports Search module.
 * This component supports a variety of use cases on different pages.
 */

interface ForgotPassFormProps {
	setIsForgotPass: (values: boolean) => void;
	fromLoginPage?: boolean;
	setLoginTab: () => void;
}

const ForgotPassForm: FC<ForgotPassFormProps> = props => {
	const { setIsForgotPass, fromLoginPage, setLoginTab } = props;
	const [isSuccessPage, setIsSuccessPage] = useState(false);
	const [successPageEmail, setSuccessPageEmail] = useState('');

	return (
		<Grid container justify="flex-end">
			<Conditional show={isSuccessPage}>
				<SuccessDialog
					fromLoginPage={fromLoginPage}
					setIsForgotPass={setIsForgotPass}
					setSuccessPage={setIsSuccessPage}
					successPageEmail={successPageEmail}
				/>
			</Conditional>
			<Conditional show={!isSuccessPage}>
				<ForgotPasswordDialog
					fromLoginPage={fromLoginPage}
					setIsForgotPass={setIsForgotPass}
					setSuccessPage={setIsSuccessPage}
					setSuccessPageEmail={setSuccessPageEmail}
					setLoginTab={setLoginTab}
				/>
			</Conditional>
		</Grid>
	);
};

export default ForgotPassForm;
